import { inject, injectable } from "inversify";
import { LandingServiceID } from "./symbols";
import type { ILandingSessionManager } from "@/lib/types/store";
import type {
  IDemoCallControlManager,
  IDemoRecapManager,
} from "@/lib/types/demo-session";

export interface ILandingRootStore {
  session: ILandingSessionManager;
  demoRecap: IDemoRecapManager;
  demoCall: IDemoCallControlManager;
}

@injectable()
export class LandingRootStore implements ILandingRootStore {
  constructor(
    @inject(LandingServiceID.SessionStore)
    readonly session: ILandingSessionManager,
    @inject(LandingServiceID.DemoRecapStore)
    readonly demoRecap: IDemoRecapManager,
    @inject(LandingServiceID.DemoCallControlStore)
    readonly demoCall: IDemoCallControlManager,
  ) {}
}

// https://github.com/inversify/InversifyJS/issues/997
Object.getPrototypeOf(LandingRootStore.prototype).constructor = Object;
